import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import "./index.css"
import kebabCase from "lodash/kebabCase"

const BlogPage = ({ data }) => (
  <Layout>
    <SEO title="Blogs" />
    <h3
      style={{
        color: "#333333",
        marginTop: "2em",
        fontSize: `1.4rem`,
        margin: `0 0 2rem`,
      }}
    >
      Blogs{" "}
    </h3>
    <hr />

    {data.allMarkdownRemark.edges.map(post => (
      <div key={post.node.id}>
        <Link to={post.node.frontmatter.path}>
          <h3
            style={{
              color: "#42556a",
              fontSize: "22px",
              marginBottom: `2px`,
            }}
          >
            {post.node.frontmatter.title}
          </h3>
        </Link>
        {post.node.frontmatter.tags ? (
          <small
            style={{
              color: "#925FCF",
              marginTop: `0px`,
              boxShadow: `inset 0 -6px 0 rgba(0,255,0,0.4)`,
            }}
          >
            <Link to={`/tags/${kebabCase(post.node.frontmatter.tags[0])}/`}>
              {" "}
              {post.node.frontmatter.tags[0]}
            </Link>{" "}
          </small>
        ) : null}
        <br />
        <small style={{ color: "#92a1b1", marginTop: `0px` }}>
          {post.node.frontmatter.date}
        </small>{" "}
        <p style={{ color: `#42556a`, fontSize: `0.98rem`, marginBottom: `10px` }}>
          {post.node.excerpt}
        </p>
        <Link
          to={post.node.frontmatter.path}
          style={{ color: "#925FCF", fontSize: "17px" }}
        >
          {" "}
          Read More{" "}
        </Link>
        <br />
        <br />
        <br />
      </div>
    ))}
  </Layout>
)

export const pageQuery = graphql`
  query BlogIndexQuery {
    allMarkdownRemark(
      filter: { frontmatter: { type: { eq: "Main" } } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          id
          frontmatter {
            path
            tags
            title
            date(formatString: "MMMM DD, YYYY")
            author
          }
          excerpt
        }
      }
    }
  }
`

export default BlogPage
